import axios from 'axios';
import gsap from 'gsap';
import load from './load';
import loader from './loader';

const filters = Array.from(document.querySelectorAll('.js-journal-filter'));
const container = document.querySelector('#ajax-items-container');
const activeClass = 'journal-category-is-active';

function updateHistory(url) {
  history.pushState(url, null, url);
}

function updateItems(url) {
  loader.init();
  gsap.to(container, {
    opacity: 0,
    duration: 0.1,
  }).then(() => {
    axios.get(url).then((res) => {
      // Get new page content
      const parser = new DOMParser();
      const resHTML = parser.parseFromString(res.data, "text/html");
      const content = resHTML.querySelector('#ajax-items');
      // Replace container content
      container.innerHTML = '';
      container.append(content);
      gsap.to(container, {
        opacity: 1,
        duration: 0.1
      })
      .then(() => {
        // Don't reset scroll position
        load(false);
      })
      .then(loader.stop)
    }).catch((err) => {
      console.log(err);
    })
  })
}

function updateClasses(filter) {
  // Update active filter
  const active = document.querySelector(`.${activeClass}`);
  active.classList.remove(activeClass);
  filter.parentElement.classList.add(activeClass);
}

function handleFilter(e) {
  e.preventDefault();
  const clicked = e.currentTarget;
  const url = clicked.href;
  updateClasses(clicked);
  updateHistory(url);
  updateItems(url);
}

function init() {
  if (!filters.length) {
    return;
  }
  filters.forEach(filter => {
    filter.addEventListener('click', handleFilter);
  });
}

init();
